import { render, staticRenderFns } from "./active-menu-modal.vue?vue&type=template&id=8d91b236&"
import script from "./active-menu-modal.vue?vue&type=script&lang=js&"
export * from "./active-menu-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports